/**
 * @type {number}
 */
let idCounter = 0;

/**
 * @param {HTMLElement} element
 * @param {CSSStyleDeclaration} [style]
 * @returns {boolean}
 */
export function isHidden(element, style = undefined) {
  if (style) {
    return style.display === 'none';
  }

  return element.offsetParent === null;
}

/**
 * Generate a unique id for an element.
 *
 * @param {string} [prefix]
 * @returns {string}
 */
export function uniqueId(prefix = '') {
  return (prefix ? `${prefix}-` : '') + (++idCounter);
}

/**
 * Get the width of the element including the padding and border-width.
 *
 * @param {?HTMLElement} element
 * @returns {number}
 */
export function width(element) {
  return element?.getBoundingClientRect().width ?? 0;
}

/**
 * Get the height of the element including the padding and border-width.
 *
 * @param {?HTMLElement} element
 * @returns {number}
 */
export function height(element) {
  return element?.getBoundingClientRect().height ?? 0;
}

/**
 * @param {string} selector
 * @param {HTMLElement|Document} [context]
 * @returns {?HTMLElement}
 */
export function qs(selector, context = document) {
  return context.querySelector(selector);
}

/**
 * @param {string} selector
 * @param {HTMLElement|Document} [context]
 * @returns {HTMLElement[]}
 */
export function qsa(selector, context = document) {
  return Array.from(context.querySelectorAll(selector));
}

/**
 * @template {HTMLElement} TElement
 * @param {string|{toString(): string}} markup
 * @returns {TElement}
 */
export function create(markup) {
  const template = document.createElement('template');
  template.innerHTML = String(markup ?? '').trim();

  const element = /** @type {TElement} */ (
    template.content.firstElementChild
  );

  return element;
}

/**
 * @template TReturnValue
 * @param {string} selector
 * @param {(elements: HTMLElement[]) => TReturnValue} callback
 * @param {() => TReturnValue} [fallback]
 * @returns {?TReturnValue}
 */
export function whenFound(selector, callback, fallback = null) {
  const elements = qsa(selector);

  if (elements.length === 0) {
    return fallback?.();
  }

  return callback(elements);
};